import {useQuery} from "@tanstack/react-query";
import {fetchBook, fetchBookDetail, fetchChapter, searchBooks, fetchProgress, fetchBookmarks, fetchChapterChars} from "../api/book";

export const useBook = () => {
    return useQuery({
        queryKey: ['books'],
        queryFn: fetchBook
    })
}

export const useBookDetail = (bookId) => {
    return useQuery({
        queryKey: ['bookDetail', bookId],
        queryFn: () => fetchBookDetail(bookId),
        enabled: !!bookId,
    })
}

export const useChapter = (bookId, chapterId) => {
    return useQuery({
        queryKey: ['chapter', bookId, chapterId],
        queryFn: () => fetchChapter(bookId, chapterId),
        enabled: !!bookId && !!chapterId,
    })
}

// 按章节获取字符释义（独立 API，与 chapter 内嵌 chars 互补）
export const useChapterChars = (bookId, chapterId) => {
    return useQuery({
        queryKey: ['chapterChars', bookId, chapterId],
        queryFn: () => fetchChapterChars(bookId, chapterId),
        enabled: !!bookId && !!chapterId,
    })
}

export const useSearchBooks = (keyword) => {
    return useQuery({
        queryKey: ['books', 'search', keyword],
        queryFn: () => searchBooks(keyword),
        enabled: !!keyword && keyword.length > 0,
    })
}

export const useProgress = (bookId) => {
    return useQuery({
        queryKey: ['progress', bookId],
        queryFn: () => fetchProgress(bookId),
        enabled: !!bookId,
    })
}

export const useBookmarks = (bookId) => {
    return useQuery({
        queryKey: ['bookmarks', bookId],
        queryFn: () => fetchBookmarks(bookId),
        enabled: !!bookId,
    })
}
